import React, { useRef, useState } from "react";
import { Button, Card } from "antd";
import { DownloadOutlined, FileTextOutlined, DatabaseOutlined } from "@ant-design/icons";
import { useRestApi } from "~/hooks";
import styles from "./reports-page.module.css";

const {
  ["container"]: containerClassName,
  ["download-buttons-container"]: downloadButtonsContainer,
  ["report-card"]: reportCardClassName,
} = styles as any;

type ReportType = "usage" | "assumptionsexclusions";

export const DownloadReportsPage = () => {
  const [downloading, setDownloading] = useState(false);
  const [downloadingAE, setDownloadingAE] = useState(false);
  const downloadRef = useRef<HTMLAnchorElement | null>(null);
  const restApi = useRestApi();

  const onDownload = async (type: ReportType) => {
    switch (type) {
      case "usage": {
        setDownloading(true);
        const useageDownloader = await restApi.downloadUsageReport();
        if (downloadRef.current) {
          await useageDownloader.download(downloadRef.current);
          setDownloading(false);
        }
        break;
      }
      case "assumptionsexclusions": {
        setDownloadingAE(true);
        const fileDownloader = await restApi.downloadAssumptionsExclusionsExport();
        if (downloadRef.current) {
          await fileDownloader.download(downloadRef.current);
          setDownloadingAE(false);
        }
        break;
      }
    }
  };

  return (
    <div className={downloadButtonsContainer}>
      <Card className={reportCardClassName}>
        <div className={containerClassName}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <FileTextOutlined style={{ fontSize: "20px", color: "#1890ff" }} />
            <div>
              <div style={{ fontWeight: 500, marginBottom: "4px" }}>Usage Report</div>
              <div style={{ fontSize: "13px", color: "#8c8c8c" }}>
                A report of all created matters by users
              </div>
            </div>
          </div>
          <Button
            type="primary"
            icon={<DownloadOutlined />}
            onClick={() => onDownload("usage")}
            loading={downloading}
          >
            Download
          </Button>
        </div>
      </Card>

      <Card className={reportCardClassName}>
        <div className={containerClassName}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <DatabaseOutlined style={{ fontSize: "20px", color: "#52c41a" }} />
            <div>
              <div style={{ fontWeight: 500, marginBottom: "4px" }}>Library Export</div>
              <div style={{ fontSize: "13px", color: "#8c8c8c" }}>
                Export Assumptions and Exclusions Library
              </div>
            </div>
          </div>
          <Button
            type="primary"
            icon={<DownloadOutlined />}
            onClick={() => onDownload("assumptionsexclusions")}
            loading={downloadingAE}
          >
            Download
          </Button>
        </div>
      </Card>
      <a ref={(e) => { downloadRef.current = e; }} />
    </div>
  );
};
